import * as d3 from "d3";

export const getShapeInformation = (
  subgroupScale: any,
  categoricalScale: any,
) => {
  const scaleWidth =
    subgroupScale?.scale?.bandwidth() || categoricalScale?.scale?.bandwidth();

  const scalePosition = (d: any) =>
    categoricalScale?.scale(d.groupKey) +
    (subgroupScale?.scale(d.subgroupKey) || 0);

  const shapeWidth = () => d3.min([scaleWidth, 180]);

  const shapeCenter = (d: any) => scalePosition(d) + scaleWidth / 2;

  const shapePosition = (d: any) => {
    return shapeCenter(d) - shapeWidth() / 2;
  };

  return {
    shapePosition,
    shapeWidth,
  };
};
